import { getUserInfo } from '../services/auth';
import { fetchExams } from '../services/exams';

/**
 * The server switched the active exam (select): reload the profile
 * and the exams the way the app does after an exam switch.
 */
export const refreshAfterMcGrawHillChange = async (): Promise<void> => {
  await Promise.all([getUserInfo(), fetchExams()]);
};
